import { LastAssessment } from '../../lesson-carousel/last-assessment';
import { UnitQuizCooldownRemaining } from './unit-quiz-cooldown-remaining';

export const DEFAULT_UNIT_QUIZ_COOLDOWN_HOURS = 24;

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;

export function isTakeUnitQuizLocked(
  lastAssessment: LastAssessment | null | undefined,
  cooldownHours: number = DEFAULT_UNIT_QUIZ_COOLDOWN_HOURS,
  now: number = Date.now()
): boolean {
  if (!lastAssessment || lastAssessment.passed !== false || !lastAssessment.completedAt) {
    return false;
  }

  return now - lastAssessment.completedAt.getTime() < cooldownHours * HOUR_MS;
}

export function resolveUnitQuizCooldownHours(value: number | null | undefined): number {
  return typeof value === 'number' && value > 0 ? value : DEFAULT_UNIT_QUIZ_COOLDOWN_HOURS;
}

// Round up so a locked quiz never reads 0h 0m.
export function getUnitQuizCooldownRemaining(
  completedAt: Date,
  cooldownHours: number,
  now: number = Date.now()
): UnitQuizCooldownRemaining {
  const remainingMs = completedAt.getTime() + cooldownHours * HOUR_MS - now;
  const totalMinutes = Math.max(0, Math.ceil(remainingMs / MINUTE_MS));
  return { hours: Math.floor(totalMinutes / 60), minutes: totalMinutes % 60 };
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/take-unit-quiz/take-unit-quiz-lock.helpers.ts